import { CSSObject } from "@mui/material/styles";
import { themeShadows } from "src/theme-mui/tokens/shadows";

export const containedMap = {
    gray: {
        backgroundColor: "var(--mui-palette-gray-800)",
        color: "white",
        "&:hover": {
            backgroundColor: "var(--mui-palette-gray-600)",
        },
        "&:active": {
            backgroundColor: "var(--mui-palette-gray-900)",
        },
        "&:focus": {
            backgroundColor: "var(--mui-palette-gray-900)",
        },
        "&:disabled": {
            backgroundColor: "var(--mui-palette-gray-50)",
            color: "var(--mui-palette-gray-200)",
        },
    },
    green: {
        backgroundColor: "var(--mui-palette-green-600)",
        color: "white",
        "&:hover": {
            backgroundColor: "var(--mui-palette-green-500)",
        },
        "&:active": {
            backgroundColor: "var(--mui-palette-green-700)",
        },
        "&:focus": {
            backgroundColor: "var(--mui-palette-green-700)",
        },
        "&:disabled": {
            backgroundColor: "var(--mui-palette-green-100)",
            color: "var(--mui-palette-green-300)",
        },
        "&.Mui-focusVisible": {
            boxShadow: themeShadows.focusVisible,
        },
    },
    whiteAlpha: {
        backgroundColor: "white",
        color: "var(--mui-palette-gray-800)",
        "&:hover, &:focus, &:active": {
            backgroundColor: "var(--mui-palette-whiteAlpha-700)",
        },
        "&:disabled": {
            backgroundColor: "transparent",
            color: "var(--mui-palette-whiteAlpha-400)",
        },
    },
};

export const outlinedMap = {
    gray: {
        color: "var(--mui-palette-gray-800)",
        "&:hover": {
            backgroundColor: "var(--mui-palette-gray-50)",
        },
        "&:active": {
            backgroundColor: "var(--mui-palette-gray-100)",
        },
        "&:focus": {
            backgroundColor: "var(--mui-palette-gray-100)",
        },
        '&[aria-expanded="true"]': {
            backgroundColor: "var(--mui-palette-gray-100)",
        },
        "&:disabled": {
            color: "var(--mui-palette-gray-200)",
        },
    },
    green: {
        color: "var(--mui-palette-green-600)",
        "&:hover": {
            backgroundColor: "var(--mui-palette-green-100)",
        },
        "&:active": {
            backgroundColor: "var(--mui-palette-green-200)",
        },
        "&:focus": {
            backgroundColor: "var(--mui-palette-green-200)",
        },
        '&[aria-expanded="true"]': {
            backgroundColor: "var(--mui-palette-green-200)",
        },
        "&:disabled": {
            color: "var(--mui-palette-green-300)",
        },
        "&.Mui-focusVisible": {
            boxShadow: themeShadows.focusVisible,
        },
    },
};

export const ghostMap = {
    gray: outlinedMap.gray,
    green: outlinedMap.green,
};

export const ghostUnderlineMap = {
    gray: {
        ...outlinedMap.gray,
        textDecoration: "underline",
        "&:hover": { ...outlinedMap.gray["&:hover"], textDecoration: "underline" },
        textUnderlineOffset: "3.36px",
    },
    green: {
        ...outlinedMap.green,
        textDecoration: "underline",
        "&:hover": { ...outlinedMap.green["&:hover"], textDecoration: "underline" },
        textUnderlineOffset: "3.36px",
    },
};

export const buttonRootStyles: CSSObject = {
    textTransform: "none",
    color: "inherit",
    lineHeight: "1.2",
    boxShadow: "none",
    justifyContent: "center",
    transition: "all 250ms",
    userSelect: "none",
    position: "relative",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    outline: "none",
    borderRadius: "8px",
    fontWeight: "600",
    flexShrink: "initial",
    padding: 0,
    "&:hover": {
        boxShadow: "none",
        backgroundColor: "transparent",
    },
    "&:active": {
        boxShadow: "none",
        backgroundColor: "transparent",
    },
    "&:disabled": {
        boxShadow: "none",
        cursor: "not-allowed",
    },
    "&.Mui-focusVisible": {
        boxShadow: themeShadows.focusVisible,
    },
    "& .MuiButton-startIcon": {
        marginLeft: 0,
        marginRight: 0,
    },
};
